import api from "../api";

const api_type = 'v1'

export const GetHomeSummary = params => { return api.post(api_type+`/home/summary`, params) }
export const GetHomeSummaryDate = params => { return api.post(api_type+`/home/summary_date`, params) }
export const GetHomeProduct = params => { return api.post(api_type+`/home/product`, params) }
export const EditPaymentTerm = params => { return api.post(api_type+`/home/edit_payment_term`, params) }
export const GetHomeSummaryProduct = params => { return api.post(api_type+`/home/summary_product`, params) }

export const GetSettlementMonthData = params => { return api.post(api_type+`/settlement_month_new1`, params) }
export const AddExchangeRate = params => { return api.post(api_type+`/exchange_rate/add`, params) }
export const GetExchangeRateList = params => { return api.post(api_type+`/exchange_rate/list`, params) }



// WEBPACK FOOTER //
// ./src/api/v1/home_api.js